<template>
  <kernel-chart-wrapper
    :tooltip-handler="tooltipHandler"
    title="Order validation statuses"
  >
    <template #default="{ options }">
      <v-bar
        :data="chartData"
        :legend-visible="false"
        :settings="chartSettings"
        :extend="options.chartExtend"
        :text-style="options.textStyle"
        :colors="['#19d4ae', '#fa6e86']"
        :height="$attrs.loading ? 'auto' : '320px'"
        width="100%"
      />
    </template>
  </kernel-chart-wrapper>
</template>

<script>
import { mapState } from 'vuex';

import VBar from 'v-charts/lib/bar.common';

import { formatDate } from '@helpers';

import { namespace as DashboardNamespace } from '../store.types';

const titles = {
  validCount: 'Valid',
  invalidCount: 'Invalid',
};

export default {
  name: 'KernelOrderValidationStatusesChart',
  components: { VBar },
  computed: {
    ...mapState(DashboardNamespace, {
      chartData: ({ stats: { orderValidationStatuses: stat } }) => ({
        columns: ['date', 'validCount', 'invalidCount'],
        rows: (stat || [])
          .map((v) => ({ ...v, date: formatDate(v.date, { dateFormat: 'dd MMM yyyy' }) })),
      }),
    }),
    chartSettings: () => ({
      stack: {
        statuses: ['validCount', 'invalidCount'],
      },
    }),
  },
  methods: {
    tooltipHandler: (values) => values.map((v) => ({ ...v, title: titles[v.title] })),
  },
};
</script>
